




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import vue from 'vue';
import { colors } from '@/config';

More(Highcharts);

@Component({components: {Chart}})
export default class ProfitLoss extends Vue {
    @Prop() readonly profitloss!: any;

    chartOptions: any = {
        chart: {
            type: 'waterfall',
            backgroundColor: 'transparent',
        },

        credits: {
            enabled: false,
        },

        title: {
            text: '',
        },

        xAxis: {
            type: 'category',
            labels: {
                style: {
                    fontSize: '1.2rem',
                },
            },
        },

        yAxis: {
            title: {
                text: '',
            },
            labels: {
                style: {
                    fontSize: '1.2rem',
                },
                formatter() { return (vue as any).options.filters.KR((this as any).value); },
            },
            tickPixelInterval: 150,
        },

        legend: {
            enabled: false,
        },

        tooltip: {
            headerFormat: '<span style="font-size: 1.5rem">{point.key}</span><br/>',
            pointFormat: '<span><b>{point.y:,.0f} tkr</b></span>',
            style: {
                fontSize: '1.5rem',
            },
        },

        series: [],
    };

    mounted() {
        if (this.profitloss) {
            this.chartOptions.series = this.getSeries();
        }
    }

    @Watch('profitloss', { immediate: true, deep: true })
    profitlossChanged() {
        if (this.profitloss) {
            this.chartOptions.series = this.getSeries();
        }
    }

    getSeries() {
        return [{
            upColor: colors.Secondary,
            color: colors.Tertiary,
            data: [{
                name: 'Netto-omsättning',
                y: this.profitloss.A,
                color: colors.Primary,
            }, {
                name: 'Övr. rörelse-intäkter',
                y: this.profitloss.B,
            }, {
                name: 'Kostnader för varor & material',
                y: this.profitloss.D,
            }, {
                name: 'Övr. externa kostnader',
                y: this.profitloss.F,
            }, {
                name: 'Personal-kostnader',
                y: this.profitloss.G,
            }, {
                name: 'Övriga rörelse-kostnader',
                y: this.profitloss.H,
            }, {
                name: 'Av- och ned-skrivningar',
                y: this.profitloss.J,
            }, {
                name: 'Finansiella poster',
                y: this.profitloss.L + this.profitloss.M,
                color: this.profitloss.L + this.profitloss.M > 0 ? colors.Secondary : colors.LightGrey,
            }, {
                name: 'Boksluts-disp.',
                y: this.profitloss.O,
                color: this.profitloss.O > 0 ? colors.Secondary : colors.LightGrey,
            }, {
                name: 'Skatt',
                y: this.profitloss.Q,
                color: this.profitloss.Q > 0 ? colors.Secondary : colors.LightGrey,
            }, {
                name: 'Årets resultat',
                isSum: true,
                color: this.profitloss.R > 0 ? colors.Green : colors.Red,
            },
            ],

            pointPadding: 0,
        }];
    }
}
